import { useContext } from 'react'; 
import { PopUpContext } from '../../contexts/ui.context';
import './pop-up.styles.scss';


const PopUp = ({info, a='Continue', b='Cancel', go }) => {
	const { setCurrentPopUp } = useContext(PopUpContext);

	const cancel = () => {
		setCurrentPopUp(null);
	}


	return(
		<div className='pop-up-container'>
			<div className='pop-up'  style={{
			borderColor: 'black'
			}}>
				<div className='pop-up-info'><h4>{info}</h4></div>
				<div className='buttons-div'>
					<button className='a' onClick={go}>{a}</button>
					<button className='b' onClick={cancel}>{b}</button>
				</div>
			</div>
		</div>
	);
}

export default PopUp;